import { Decimal, StabilityDepositChange } from "@liquity/lib-base";
import { Button } from '../PSY/Button'

import { useLiquity } from "../../hooks/LiquityContext";
import { useTransactionFunction } from "../Transaction";

type StabilityDepositActionProps = {
  spAddress: string;
  transactionId: string;
  change: StabilityDepositChange<Decimal>;
};

export const StabilityDepositAction: React.FC<StabilityDepositActionProps> = ({
  children,
  spAddress,
  transactionId,
  change
}) => {
  const { liquity } = useLiquity();

  const [sendTransaction] = useTransactionFunction(
    transactionId,
    change.depositSLSD
      ? liquity.send.depositSLSDInStabilityPool.bind(liquity.send, spAddress, change.depositSLSD, undefined)
      : liquity.send.withdrawSLSDFromStabilityPool.bind(liquity.send, spAddress, change.withdrawSLSD)
  );

  return <Button onSubmit={sendTransaction} className="flex flex-1">{children}</Button>;
};
